module.exports = __webpack_public_path__ + "img/ai-base-icon.cf3c1316.png";